<template>
  <p>Experian requires us to ask you a few questions to verify your identity.</p>
  <p class="font-semibold">Your information is not stored or shared.</p>

  <h5 class="py-5 md:text-xl">
    Question {{ currentQuestionIndex + 1 }} of {{ totalQuestionCount }}
  </h5>

  <p class="py-1">{{ currentQuestion.question }}</p>

  <div class="flex flex-col py-3">
    <div
      v-for="(answer, index) in currentQuestion.answers"
      :key="`answer-${index}`"
      class="flex items-center py-1"
    >
      <label :for="`answer-${index}`" class="inline-flex items-center">
        <input
          :name="`answer-${index}`"
          :id="`answer-${index}`"
          type="radio"
          class="border-gray-300 text-brand-green focus:ring-brand-green"
          :value="`${index + 1}`"
          v-model="selected[currentQuestionIndex]"
        />
        <span class="ml-3 block text-brand-black">{{ answer }}</span></label
      >
    </div>
  </div>

  <div class="flex py-5 md:w-1/3 md:mx-auto">
    <PrimaryButton
      :disabled="!selected[currentQuestionIndex] || isUserLoading || isApplicationLoading"
      :is-loading="isUserLoading || isApplicationLoading"
      @click="nextQuestion()"
      >{{
        currentQuestionIndex === totalQuestionCount - 1 ? "Submit answers" : "Next question"
      }}</PrimaryButton
    >
  </div>
</template>
<script>
import { mapGetters } from "vuex"
import {
  USER_ANSWER_EXPERIAN_QUESTIONS,
  APPLICATION_ANSWER_EXPERIAN_QUESTIONS,
  USER_GET
} from "@/store/types"

/*
  questions: [{ question: '', answers: ["", ""]}]
*/
export default {
  computed: {
    ...mapGetters([
      "getUserExperianQuestions",
      "isUserLoading",
      "getApplicationExperianQuestions",
      "isApplicationLoading"
    ]),
    totalQuestionCount() {
      if (this.context === "applicant") {
        return this.getApplicationExperianQuestions
          ? this.getApplicationExperianQuestions.length
          : 0
      }

      return this.getUserExperianQuestions ? this.getUserExperianQuestions.length : 0
    },
    currentQuestion() {
      if (this.context === "applicant") {
        return this.getApplicationExperianQuestions
          ? this.getApplicationExperianQuestions[this.currentQuestionIndex]
          : {}
      }
      return this.getUserExperianQuestions
        ? this.getUserExperianQuestions[this.currentQuestionIndex]
        : {}
    }
  },
  mounted() {
    if (this.context === "applicant" && !this.getApplicationExperianQuestions) {
      this.$router.push({
        name: "apply_verify_disclaimer",
        params: { id: this.$route.params.id }
      })
    } else if (this.context === "landlord" && !this.getUserExperianQuestions) {
      this.$router.push({ name: "dashboard_verify_disclaimer" })
    }
  },
  props: {
    context: {
      type: String,
      default: "landlord"
    }
  },
  data() {
    return {
      currentQuestionIndex: 0,
      selected: {},
      errorMessage: ""
    }
  },
  methods: {
    nextQuestion() {
      if (this.currentQuestionIndex < this.totalQuestionCount - 1) {
        this.currentQuestionIndex = this.currentQuestionIndex + 1
      } else {
        this.submitAnswers()
      }
    },
    async submitAnswers() {
      const answers = Object.keys(this.selected)
        .sort()
        .reduce((arr, key) => {
          arr.push(this.selected[key])
          return arr
        }, [])

      const id = this.$route.params.id

      try {
        if (this.context === "applicant") {
          await this.$store.dispatch(APPLICATION_ANSWER_EXPERIAN_QUESTIONS, {
            id,
            answers
          })
          this.$router.push({ name: "apply_verify_success", params: { id } })
        } else {
          await this.$store.dispatch(USER_ANSWER_EXPERIAN_QUESTIONS, {
            answers
          })
          //Reload current user for updated RSP
          await this.$store.dispatch(USER_GET)
          this.$router.push({ name: "dashboard_verify_success" })
        }
      } catch (err) {
        //this.errorMessage = err.response.data.error
        if (this.context === "applicant") {
          this.$router.push({ name: "apply_verify_failure", params: { id } })
        } else {
          this.$router.push({ name: "dashboard_verify_failure" })
        }
      }
    }
  }
}
</script>
